module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('vue-good-table', {
    attrs: {
      "columns": _vm.columnsValues,
      "rows": _vm.currentCommands,
      "pagination-options": {
        enabled: true,
        perPage: '10',
        perPageDropdown: [10],
        mode: 'records',
        rowsPerPageLabel: 'Reportes por página',
        ofLabel: 'de',
        allLabel: 'Todas',
        prevLabel: 'Anterior',
        nextLabel: 'Siguiente'
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("No existen resultados")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-859976ca!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UIComponents/FuelCutHistory.vue
// module id = 255
// module chunks = 3